export const EARTH_RADIUS_M = 6371000;

export const toRad = (deg: number): number => (deg * Math.PI) / 180;

/**
 * Haversine distance between two points in degrees.
 * Returns distance in meters.
 */
export function haversineDistanceMeters(
  lat1Deg: number,
  lon1Deg: number,
  lat2Deg: number,
  lon2Deg: number,
): number {
  const R = EARTH_RADIUS_M;
  const dLat = toRad(lat2Deg - lat1Deg);
  const dLon = toRad(lon2Deg - lon1Deg);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1Deg)) *
      Math.cos(toRad(lat2Deg)) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
